import { useNavigate, useParams } from 'react-router-dom';
import { UserForm } from '../features/users/UserForm';
import { useUpdateUser, useUser } from '../features/users/api';
import type { UpdateUserInput } from '@app/shared';
import { getApiErrorMessage } from '../lib/api-client';

export function UserEditPage(): JSX.Element {
  const navigate = useNavigate();
  const params = useParams();
  const id = Number(params.id);
  const { data, isLoading, isError, error } = useUser(Number.isFinite(id) ? id : undefined);
  const mutation = useUpdateUser(id);

  if (isLoading) return <div role="status" className="text-slate-500">載入中...</div>;
  if (isError || !data) {
    return (
      <div role="alert" className="text-red-600">
        載入失敗：{getApiErrorMessage(error, '找不到使用者')}
      </div>
    );
  }

  return (
    <section>
      <header className="mb-4">
        <h1 className="text-2xl font-semibold">編輯使用者</h1>
      </header>
      {mutation.isError ? (
        <div role="alert" className="mb-3 text-red-600">
          儲存失敗：{getApiErrorMessage(mutation.error, '未知錯誤')}
        </div>
      ) : null}
      <UserForm
        mode="edit"
        defaultValues={data.data}
        submitting={mutation.isPending}
        onSubmit={(values) => {
          mutation.mutate(values as UpdateUserInput, {
            // 存完回上一頁而不是跳 /settings/users 頂層(REQ-20260820006):
            // 使用者是從哪一層點進來的就回哪一層,不必再自己找回原本的位置
            onSuccess: () => navigate(-1),
          });
        }}
      />
    </section>
  );
}
